<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.7 0C3.6 0 2.6.4 1.8 1.2S.7 2.9.7 4v16c0 1.1.4 2.1 1.2 2.8.7.8 1.7 1.2 2.8 1.2h14.7c.4 0 .7-.1.9-.4.3-.3.4-.6.4-.9 0-.4-.1-.7-.4-.9-.3-.3-.6-.4-.9-.4H4.7c-.4 0-.7-.1-.9-.4-.3-.3-.4-.6-.4-.9V4c0-.4.1-.7.4-.9s.6-.4.9-.4h14.7c.4 0 .7-.1.9-.4.3-.3.4-.6.4-.9 0-.4-.1-.7-.4-.9-.3-.4-.6-.5-1-.5H4.7zm12.9 5.7c-.1-.1-.3-.2-.4-.3-.2-.1-.3-.1-.5-.1s-.4 0-.5.1c-.2.1-.3.2-.4.3-.1.1-.2.3-.3.4-.1.2-.1.3-.1.5s0 .4.1.5c.1.2.2.3.3.4l3.1 3.1H7.3c-.4 0-.7.1-.9.4-.3.3-.4.6-.4 1s.1.7.4.9c.3.2.6.4.9.4h11.4l-3.1 3.1c-.2.3-.4.6-.4.9 0 .3.1.7.4.9.2.2.6.4.9.4s.7-.1.9-.4l5.3-5.3c.2-.3.4-.6.4-.9 0-.4-.1-.7-.4-.9l-5.1-5.4z"
    />
  </svg>
</template>
